exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-area[data-v-3b4fcd37] {\n  margin-bottom: 20px;\n}\n.pagination-wrap[data-v-3b4fcd37] {\n  text-align: right;\n  padding: 30px 20px;\n}\n.remark[data-v-3b4fcd37] {\n  font-size: 18px;\n  line-height: 26px;\n  color: #f56c6c;\n  font-weight: bold;\n  width: 40%;\n}\n", ""]);

// exports
